export default {
  users: "Users",
  Profile: "Profile",
  addUsers: "AddUsers",
  editUsers: "EditUsers",
};
